<div class="view-mode-info" *ngIf="opened">
  <i class="fas" [class.fa-eye]="!isEditable" [class.fa-pen]="isEditable"></i>

  <span *ngIf="isEditable">{{ 'TDRAW.TYPE_EDIT' | translate }}</span>
  <span *ngIf="!isEditable">{{ 'TDRAW.TYPE_VIEW' | translate }}</span>

  <button (click)="opened = false">x</button>
</div>
